import { motion } from "framer-motion";

// Media logos - using text placeholders that look like logos
const pressLogos = [
  {
    name: "COSMOPOLITAN",
    url: "https://www.cosmopolitan.com",
    style: "font-serif text-xl sm:text-2xl md:text-3xl font-bold tracking-tight",
  },
  {
    name: "ELLE",
    url: "https://www.elle.com",
    style: "font-sans text-2xl sm:text-3xl md:text-4xl font-black tracking-[0.3em]",
  },
  {
    name: "VOGUE",
    url: "https://www.vogue.com",
    style: "font-serif text-xl sm:text-2xl md:text-3xl font-light tracking-[0.4em]",
  },
  {
    name: "FORBES",
    url: "https://www.forbes.com",
    style: "font-serif text-lg sm:text-xl md:text-2xl font-normal tracking-wider italic",
  },
  {
    name: "GLAMOUR",
    url: "https://www.glamour.com",
    style: "font-sans text-lg sm:text-xl md:text-2xl font-semibold tracking-widest",
  },
];

export const PressSection = () => {
  return (
    <section className="py-10 md:py-16 bg-background border-y border-border/30">
      <div className="container-calim">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-6 md:mb-8"
        >
          <p className="text-subhead text-muted-foreground">
            As Seen In
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="flex flex-wrap items-center justify-center gap-6 md:gap-12 lg:gap-16"
        >
          {pressLogos.map((logo, index) => (
            <motion.span
              key={logo.name}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 * index }}
              className={`${logo.style} text-muted-foreground/60 select-none cursor-default`}
            >
              {logo.name}
            </motion.span>
          ))}
        </motion.div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.5 }}
          className="text-center text-xs md:text-sm text-muted-foreground/50 mt-6 md:mt-8"
        >
          Our wellness accessories have been recognized by leading media outlets
        </motion.p>
      </div>
    </section>
  );
};
